<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue'

const stats = ref([
  { label: 'Students',            value: 1000, suffix: '+', current: 0 },
  { label: 'Staff',               value: 30,   suffix: '+', current: 0 },
  { label: 'Huffaz Graduated',    value: 800,  suffix: '+', current: 0 },
  { label: 'Years of Excellence', value: 13,   suffix: '+', current: 0 },
])

const statsRef = ref(null)
let observer  = null
let animated  = false

const animateStat = (stat) => {
  const duration = 1800
  const start    = performance.now()
  const tick     = (now) => {
    const p = Math.min((now - start) / duration, 1)
    stat.current = Math.round(p * stat.value)
    if (p < 1) requestAnimationFrame(tick)
  }
  requestAnimationFrame(tick)
}

onMounted(() => {
  observer = new IntersectionObserver(([entry]) => {
    if (entry.isIntersecting && !animated) {
      animated = true
      stats.value.forEach(animateStat)
    }
  }, { threshold: 0.4 })
  if (statsRef.value) observer.observe(statsRef.value)
})

onBeforeUnmount(() => observer?.disconnect())
</script>

<template>
  <section ref="statsRef" class="bg-primary text-white py-24">
    <div class="max-w-7xl mx-auto px-6">

      <!-- Stats -->
      <div class="grid grid-cols-2 md:grid-cols-4 gap-12 text-center mb-24">
        <div v-for="(stat, i) in stats" :key="i">
          <p class="text-4xl md:text-5xl font-bold mb-2">{{ stat.current }}{{ stat.suffix }}</p>
          <p class="text-white/70 uppercase text-sm tracking-wider">{{ stat.label }}</p>
        </div>
      </div>

      <!-- Mission & Vision -->
      <div class="grid md:grid-cols-2 gap-10">
        <div class="bg-white text-gray-800 rounded-3xl p-10
                    border border-primary/20
                    shadow-lg hover:shadow-2xl hover:-translate-y-1 transition-all duration-500">
          <span class="inline-block mb-5 px-4 py-1 rounded-full bg-primary/10 text-primary text-sm font-semibold">
            Our Mission
          </span>
          <h3 class="text-2xl font-bold text-primary mb-3">Nurturing Knowledge & Character</h3>
          <p class="text-gray-600 leading-relaxed">
            To provide holistic Islamic education rooted in the Qur'an and Sunnah,
            developing leaders of integrity and faith.<br />
            <em class="text-gray-400 text-sm">"Seek knowledge from cradle to grave."</em>
          </p>
        </div>
        <div class="bg-white text-gray-800 rounded-3xl p-10
                    border border-primary/20
                    shadow-lg hover:shadow-2xl hover:-translate-y-1 transition-all duration-500">
          <span class="inline-block mb-5 px-4 py-1 rounded-full bg-primary/10 text-primary text-sm font-semibold">
            Our Vision
          </span>
          <h3 class="text-2xl font-bold text-primary mb-3">A Center of Islamic Excellence</h3>
          <p class="text-gray-600 leading-relaxed">
            To be a globally recognized institution producing scholars
            who positively impact society.
          </p>
        </div>
      </div>
    </div>
  </section>
</template>